export var defaultProps = {
    className: '',
    min: 0,
    max: 100,
    defaultValue: 0,
    step: 1,
    value: 0,
    reverse: false,
    vertical: false,
    range: false,
    disabled: false,
    handle: null,
    marks: {},
    onChange: function (value) { },
    onBeforeChange: function (value) { return true; },
};
